import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { icons } from '../icons';

export default class LandmarkMarker extends Component {

    componentDidMount() {

        
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
    }


    selectLandmark() {
        this.props.actions.selectLandmark(this.props.landmark);
    }

    render () {
        let { landmark } = this.props;
        return (
            <Link to={'/info/landmarks/' + landmark.slug} className="map__info" style={{position: 'absolute'}} onClick={this.selectLandmark.bind(this)}>
                <div className="map__overlay">
                    <div className="map__container">
                        
                        <div className="map__title">
                            {landmark.title}
                        </div>
                        <div className="map__description">
                            {landmark.content}
                        </div>
                    </div>
                </div>
                <div className="map__landmark">

                </div>
            </Link>



        );
    }
};



// WEBPACK FOOTER //
// ./src/common/components/map/LandmarkMarker.js